export const colorOptions = [
  {
    color: '#FCA92D',
    label: 'orange',
  },
  {
    color: '#16ABEB',
    label: 'blue',
  },
  {
    color: '#02C19F',
    label: 'green',
  },
  {
    color: '#FB4A4A',
    label: 'red',
  },
  {
    color: '#717E94',
    label: 'gray',
  },
  {
    color: '#263044',
    label: 'black',
  },
] as const;
